import get from 'lodash-es/get'

import {
  selectedObjectsByRecency,
  getSelectedObjects,
  mostRecentSelectedObject,
} from './selectors'
import {
  duplicateObjects,
  duplicateGrid,
  deleteObjects,
} from '../objects/actions'
import {
  getObjectForDuplication,
  getObjectsForDuplication,
  COPYABLE_CLASS_NAMES,
} from '../objects/selectors'
import CLASS_NAMES from 'config/objectClassNames'
import Util from 'components/DrawingCanvas/lib/util'
import { SELECT_OBJECTS, DESELECT_OBJECTS, DELETE_SELECTED_OBJECTS } from './action_types'
export * from './action_types'

/**
 * @param {{ objects: { id: string; className: string }[] }} payload
 */
export const selectObjects = payload => (dispatch, getState) => dispatch({
  type: SELECT_OBJECTS,
  payload,
  globalState: getState(),
})

/**
 * @param {{ objects: { id: string }[] } | { selectedObjects: { id: string }[] } | {}} payload
 */
export const deselectObjects = payload => (dispatch, getState) => dispatch({
  type: DESELECT_OBJECTS,
  payload,
  globalState: getState(),
})

export const deleteSelectedObjects = () => (dispatch, getState) => {
  const globalState = getState()
  const selectedObjectIds = getSelectedObjects(globalState).map(o => o.id)
  if (!selectedObjectIds.length) {
    return
  }

  dispatch(deleteObjects(selectedObjectIds))
  dispatch({
    type: DELETE_SELECTED_OBJECTS,
    payload: selectedObjectIds,
    globalState,
  })
}

export const duplicateSelectedObjects = () => async (dispatch, getState, client) => {
  const selectedObjects = selectedObjectsByRecency(getState())
  const newObjects = []

  // If copying more than one item keep the objects grouped
  if (selectedObjects.length > 1) {
    // Filter out any objects that aren't capable of being copied
    const validObjects = selectedObjects.filter(obj =>
      COPYABLE_CLASS_NAMES.includes(obj.className)
    )

    if (!validObjects.length) return

    // Some objects can be safley copied as a group while
    // others require being copied relative to their original
    const groupableTypes = [CLASS_NAMES.OBSTRUCTION, CLASS_NAMES.PRODUCT]
    const groupedObjects = validObjects.filter(obj =>
      groupableTypes.includes(obj.className)
    )
    const singleObjects = validObjects.filter(
      obj => !groupableTypes.includes(obj.className)
    )

    if (groupedObjects.length) {
      const dupeObjects = await getObjectsForDuplication(client, groupedObjects, getState().objects.present)
      dupeObjects.forEach(obj => {
        if (obj.metadata) delete obj.metadata
        newObjects.push({
          obj,
          id: obj.id,
          className: obj.className,
          layerKey: obj.layerKey,
        })
      })
    }

    if (singleObjects.length) {
      singleObjects.forEach(obj => {
        const newObject = getObjectForDuplication(obj)
        if (newObject) {
          if (newObject.metadata) delete newObject.metadata
          newObjects.push({
            obj: newObject,
            id: newObject.id,
            className: obj.className,
            layerKey: obj.layerKey,
          })
        }
      })
    }
  } else {
    if (!COPYABLE_CLASS_NAMES.includes(selectedObjects[0].className)) return

    const newObject = getObjectForDuplication(selectedObjects[0])
    if (newObject) {
      if (newObject.metadata) delete newObject.metadata
      newObjects.push({
        obj: newObject,
        id: newObject.id,
        className: selectedObjects[0].className,
        layerKey: selectedObjects[0].layerKey,
      })
    }
  }

  dispatch(duplicateObjects(newObjects))
}

export const duplicateGridObjects = () => (dispatch, getState) => {
  const selectedObject = mostRecentSelectedObject(getState())
  const SHIFT = { x: 50, y: -50, z: 0 }
  const models = get(selectedObject, 'models', [])
  const newObjects = models.map(model => {
    switch (model.className) {
      case CLASS_NAMES.PRODUCT:
        return {
          ...model,
          id: Util.guid(),
          position: {
            x: model.position.x + SHIFT.x,
            y: model.position.y + SHIFT.y,
            z: model.position.z + SHIFT.z,
          },
        }
      case CLASS_NAMES.OBSTRUCTION:
        return {
          ...model,
          id: Util.guid(),
          position: {
            x: model.position.x + SHIFT.x,
            y: model.position.y + SHIFT.y,
            z: model.position.z + SHIFT.z,
          },
          positions: model.positions.map(pos => ({
            x: pos.x + SHIFT.x,
            y: pos.y + SHIFT.y,
            z: pos.z + SHIFT.z,
          })),
        }
      default:
        return {}
    }
  })
  dispatch(duplicateGrid({ objects: newObjects }))
}
